import { useEffect, useState } from 'react';
import { axiosEstimates } from './api';

/**
 * Los PDF del API de Estimates ya no se abren por id sin identificarse.
 * Este hook descarga el PDF con las cabeceras de sesión del sistema (x-id-user)
 * y devuelve una URL local (blob:) para mostrarlo en un iframe.
 */
export function usePdfObjectUrl(url: string | null) {
  const [src, setSrc] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!url) {
      setSrc(null);
      return;
    }

    let cancelled = false;
    let objectUrl: string | null = null;

    setLoading(true);
    setError(false);

    fetchPdfObjectUrl(url)
      .then(result => {
        if (cancelled) {
          URL.revokeObjectURL(result);
          return;
        }
        objectUrl = result;
        setSrc(result);
      })
      .catch(() => {
        if (!cancelled) {
          setSrc(null);
          setError(true);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  return { src, loading, error };
}

/** Descarga un PDF con la sesión del sistema y devuelve una URL local (blob:). */
export async function fetchPdfObjectUrl(url: string): Promise<string> {
  const { data } = await axiosEstimates.get<Blob>(url, { responseType: 'blob' });

  return URL.createObjectURL(data);
}
